import axios from "axios";
import JSZip from "jszip"; // Ensure the zip library is imported
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";

const extractXml = async (
  xmlUrl,
  type,
  xmlId,
  phone,
  oid,
  email,
  address,
  name,
  prefix,
  orgData,
) => {
  try {
    const token = await getOrRefreshFirebaseToken();

    const start = new Date();

    // Download file
    const response = await axios.get(xmlUrl, { responseType: "arraybuffer" });
    if (response.status !== 200)
      throw new Error(`Failed to download file: ${response.status}`);

    if (
      // Check if the file is a ZIP
      !response.headers.get("content-type")?.includes("application/zip")
    ) {
      throw new Error(
        "the provided file is a " + response.headers.get("content-type")
      );
    }
    // Extract XML content from ZIP
    const zip = await JSZip.loadAsync(response.data);
    const xmlContent = await processZipBytes(zip);
    if (!xmlContent) throw new Error("No XML file found in the ZIP archive");

    // Prepare formData for upload
    const extractUrl = `${prefix}xml/${xmlId}/extract`;
    const formData = new FormData();
    formData.append("file", new Blob([xmlContent]), "extracted.xml");
    if (type === "carbon" || type === "insulator_carbon") {
      formData.append("type", type);

      // POST formData
      const extractResponse = await axios.post(extractUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (extractResponse.status !== 200)
        throw new Error("XML extraction failed");

      // Process response
      const jsonResponse = extractResponse.data;

      const list = jsonResponse.items.map((item) => {
        return {
          X: item.index,
          num: item.sous_lot,
          nom: item.nom,
          id: item.identifiant,
          qt: item.quantité,
          un: item.unité,
        };
      });
      return { list, attestationId: "", url: "" };
    } else {
      const pdfUrl = `${prefix}xml/${xmlId}/generate_pdf`;

      const logo =
        orgData.config?.ath?.hide_my_logo === true
          ? "https://i.ibb.co/6NW6dkp/Hexagone-UXLogo3-LOW-1024.png"
          : orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";
      const pdfBody = {
        footer: `${name} - ${address}\nTéléphone : ${phone} - Mail : ${email}`,
        type,
        oid,
        logo: logo,
      };
      formData.append("request", JSON.stringify(pdfBody));

      const pdfResponse = await axios.post(pdfUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (pdfResponse.status === 200) {
        // convert to JSON
        const pdfData = pdfResponse.data;
        const url = pdfData.url.trim().replace(/"/g, "");
        const attestationId = pdfData.attestation_id;
        // get url and attestationId from dict

        return { list: [], url: url, attestationId: attestationId };
      } else {
        console.error("PDF generation failed:", pdfResponse.status);
        return { list: [], url: "", attestationId: "" };
      }
    }
  } catch (error) {
    console.error("Error in extractXml:", error.message);
    return { list: [], url: "", attestationId: "" };
  }
};

export const processZipBytes = async (zip) => {
  for (const filename in zip.files) {
    if (filename.endsWith(".xml") && !filename.includes("/")) {
      return await zip.file(filename).async("string");
    }
  }
  return null;
};

export default extractXml;
